import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withXsrfConfiguration, withInterceptorsFromDi, HttpClient } from '@angular/common/http';
import { AuthHttpInterceptor } from '../lib/shared/services/auth-http-interceptor.service';
import { XsrfHttpInterceptor } from '../lib/shared/services/xsrf-http-interceptor.service';
import { XsrfService } from '../lib/shared/services/xsrf.service';
import { EnvironmentService } from '../lib/shared/services/environment.service';
import { provideState, provideStore, StoreModule } from '@ngrx/store';
import { profileReducer } from '../lib/shared/store/profile/profile.reducers';
import { userReducer } from '../lib/shared/store/user/user.reducers';
import { ProfileEffects } from '../lib/shared/store/profile/profile.effects';
import { provideEffects } from '@ngrx/effects';
import { UserEffects } from '../lib/shared/store/user/user.effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(
      () => {
        const xsrfService = inject(XsrfService);
        const httpClient = inject(HttpClient);
        const environmentService = inject(EnvironmentService);
        httpClient.get(environmentService.apiBaseUrl() + '/xsrf', {withCredentials: true}).subscribe((res: any) => {
          xsrfService.token = res.xsrfToken;
        })
      }
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptorsFromDi(),
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: XsrfHttpInterceptor,
      multi: true
    },
    provideStore({}),
    provideState({ name: 'profile-store', reducer: profileReducer }),
    provideState({ name: 'user-store', reducer: userReducer }),
    provideEffects(ProfileEffects, UserEffects),
    provideStoreDevtools({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production
    }),
    importProvidersFrom(
      // StoreModule
    )
  ],
};
